/* eslint-disable no-unused-vars */
import { ref } from "vue";
import { useStore } from "vuex";
import { saveAs } from "file-saver";

export function useExcel() {
  const { dispatch } = useStore();
  let checked = ref([]);
  let selectAll = ref(false)

  const downloadExelFile = async (urlLink, filters) => {
    if (!checked.value.length && !selectAll.value ) return;

    const exelFile = await dispatch("downloadExelFile", {
      url: urlLink,
      filters: filters,
      ids: selectAll.value ? null : checked.value,
    });

    if (!exelFile) return;

    const blob = new Blob([exelFile], {
      type: "application/vnd.ms-excel",
    });

    let fileName = `${urlLink}`;
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(blob, fileName);
    } else {
      saveAs(blob, fileName, ".xlsx");
    }

    selectAll.value = false
    checked.value = [];
  };

  return {
    selectAll,
    downloadExelFile,
    checked,
  };
}
